import { CalendarOff, Clock, UserRound } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router";
import { cn } from "@/lib/cn";
import { routes } from "@/lib/routes";

// Employee shell navigation: three tabs, fixed at the bottom.
export function BottomNav() {
  const { t } = useTranslation("translation", { keyPrefix: "common.nav" });
  const items = [
    { to: routes.home, label: t("times"), icon: Clock, end: true },
    { to: routes.absences, label: t("absence"), icon: CalendarOff, end: false },
    { to: routes.profile, label: t("profile"), icon: UserRound, end: false },
  ];
  return (
    <nav
      aria-label={t("main")}
      className="fixed inset-x-0 bottom-0 z-30 border-zinc-200 border-t bg-white pb-safe"
    >
      <ul className="mx-auto flex max-w-2xl">
        {items.map((item) => (
          <li key={item.to} className="flex-1">
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  "flex min-h-14 flex-col items-center justify-center gap-0.5 text-xs",
                  isActive ? "font-semibold text-accent-strong" : "text-zinc-600",
                )
              }
            >
              <item.icon className="size-6" aria-hidden />
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
